import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const WatchVideo = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const videoUrl = queryParams.get("videoUrl");

  useEffect(() => {
    // Disable Right-Click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Block Developer Tools (F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U)
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "J"].includes(e.key)) ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Block PrintScreen Key
    const handlePrintScreen = (e) => {
      if (e.key === "PrintScreen") {
        navigator.clipboard.writeText(""); // Clear clipboard
        alert("Screenshots are not allowed!");
      }
    };
    document.addEventListener("keyup", handlePrintScreen);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handlePrintScreen);
    };
  }, []);

  if (!videoUrl) {
    return <h2>Invalid or Expired Video Link</h2>;
  }

  return (
    <div style={{ textAlign: "center", marginTop: "20px", position: "relative" }}>
      <h2>Watch Your Video</h2>

      {/* Floating Watermark to Discourage Screen Recording */}
      <div
        style={{
          position: "absolute",
          top: "20%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "20px",
          color: "rgba(255, 255, 255, 0.5)",
          pointerEvents: "none",
          zIndex: 10,
        }}
      >
        Confidential - No Recording Allowed
      </div>

      {/* Video with Download Disabled but Play Allowed */}
      <video
        width="80%"
        controls
        controlsList="nodownload" // Prevents direct downloads
        disablePictureInPicture // Prevents picture-in-picture mode
        onContextMenu={(e) => e.preventDefault()} // Blocks right-click on video
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default WatchVideo;
